"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "QuickBuyButton", {
  enumerable: true,
  get: function () {
    return _QuickBuyButton.QuickBuyButton;
  }
});
var _QuickBuyButton = require("./QuickBuyButton");
